import { render, staticRenderFns } from "./OutageNotificationConfiguration.vue?vue&type=template&id=3bd0143f"
import script from "./OutageNotificationConfiguration.vue?vue&type=script&lang=ts"
export * from "./OutageNotificationConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports